import React from 'react'
import { useFlag } from '@sketch/modules-common'

import LegacyEmptyState from '../EmptyState/EmptyState'
import DocumentListEmptyState from '../DocumentListEmptyState'

const TITLE = 'Trash is empty'

interface TrashListEmptyStateProps {
  search?: string
}

const TrashListEmptyState = ({ search }: TrashListEmptyStateProps) => {
  /**
   * This FF should be removed from here on the ticket
   * https://github.com/sketch-hq/Cloud/issues/16669
   */
  const isOnboardingEmptyStatesOn = useFlag('onboarding-empty-states')

  /*
   * After the FF 'onboarding-empty-states' is removed the "!isOnboardingEmptyStatesOn" condition should
   * be removed from the if statement
   * https://github.com/sketch-hq/Cloud/issues/16669
   */
  if (search || !isOnboardingEmptyStatesOn) {
    return (
      <LegacyEmptyState
        title={TITLE}
        description="Documents and projects in Trash are permanently deleted after 90 days."
        search={search}
      />
    )
  }

  return (
    <DocumentListEmptyState
      title={TITLE}
      description="Move any unwanted documents or projects here. "
    />
  )
}

export default TrashListEmptyState
